import { render, staticRenderFns } from "./RainbowBanner.vue?vue&type=template&id=64e3a16c&scoped=true&"
import script from "./RainbowBanner.vue?vue&type=script&lang=ts&"
export * from "./RainbowBanner.vue?vue&type=script&lang=ts&"
import style0 from "./RainbowBanner.vue?vue&type=style&index=0&id=64e3a16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3a16c",
  null
  
)

export default component.exports